import type { SearchFormLabelProps, SearchFormMobileTexts, SearchFormTexts } from '../model/types';
export const SEARCH_FORM_TEXTS: SearchFormTexts = {
  searchBtn: 'Найти туры',
  next: 'Выбрать',
  loadErrorTitle: 'Не получилось загрузить поиск',
  loadErrorDescription: 'Обновите страницу, обычно это помогает',
  reloadBtn: 'Обновить страницу',
};

export const SEARCH_FORM_MOBILE_TEXTS: SearchFormMobileTexts = {
  title: 'Туры',
  labels: {
    departure: 'Откуда',
    destination: 'Куда',
    date: 'Дата начала',
    nights: 'Длительность тура',
    tourists: 'Кто едет',
    childAge: 'Дети',
  },
  childAgeHint: 'Укажите возраст ребёнка на момент окончания поездки. Возраст влияет на параметры и цену предложения',
  placeholders: {
    departure: 'Город вылета',
    destination: 'Все курорты',
    date: 'Выберите даты',
  },
  routeJoin: ' — ',
};

// Без склонений: без многокомнатности форма пишет «2 взрослых».
export const HOTEL_SEARCH_FORM_TEXTS: SearchFormLabelProps = {
  dateFieldLabel: 'Дата заезда',
  touristsFieldLabel: 'Гости',
  nightsSummaryPrefix: 'С',
  searchBtnText: 'Найти отели',
};
